import { render, staticRenderFns } from "./UserAddress.vue?vue&type=template&id=68d900ab&scoped=true&"
import script from "./UserAddress.vue?vue&type=script&lang=js&"
export * from "./UserAddress.vue?vue&type=script&lang=js&"
import style0 from "./UserAddress.vue?vue&type=style&index=0&id=68d900ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d900ab",
  null
  
)

export default component.exports